// The AuctogonNativeTransfer plugin's frozen surface (BL-2678). A parity test compares these names
// with the Swift plugin's and the Android one's (NativeTransferPlugin.java, BL-2995), so a rename on one side fails CI instead of failing on a phone.

/** The name the iOS and Android plugins register under. */
export const NATIVE_TRANSFER_PLUGIN_NAME = 'AuctogonNativeTransfer';

/** The plugin event the page listens to while a screen is open. */
export const NATIVE_TRANSFER_CHANGE_EVENT = 'change';

/**
 * The plugin event the shell listens to for a notification tap (BL-2685). Its data is `{ route }`,
 * the `userInfo.route` key the notification carried. A tap that cold-starts the app is held until
 * a listener attaches.
 */
export const NATIVE_TRANSFER_ROUTE_EVENT = 'routeRequested';

/** The route key a "needs review" or "sign in" notification carries: it opens Storage & Sync (BL-2685). */
export const NATIVE_TRANSFER_STORAGE_SYNC_ROUTE = 'storage-sync';

/**
 * Every method the plugin implements. All but `setActiveScope` take `{ tenantId, userId, ...args }`;
 * `setActiveScope` takes `{ tenantId, userId }`, or both null to clear.
 */
export const NATIVE_TRANSFER_PLUGIN_METHODS = [
  'capabilities',
  'enqueue',
  'summary',
  'listRows',
  'getRow',
  'resolveFailed',
  'stagedFileIds',
  'purge',
  'requestNotificationPermission',
  'setActiveScope',
] as const;

/**
 * The first native engine that answers `getRow` (BL-2951). The page hands nothing to an older engine: its lot could
 * never learn the row's outcome. Bumped with `NativeTransferCore.engineVersion` (Swift), `TransferGateway.ENGINE_VERSION` (Java) and the memory queue.
 */
export const NATIVE_TRANSFER_MIN_ENGINE_VERSION = 2;

/** One of {@link NATIVE_TRANSFER_PLUGIN_METHODS}. */
export type NativeTransferPluginMethod = (typeof NATIVE_TRANSFER_PLUGIN_METHODS)[number];
